import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

export function PlusGate({ title, body, testId = "plus-gate" }: { title: string; body: string; testId?: string }) {
  return (
    <div data-testid={testId} className="relative overflow-hidden rounded-3xl bg-[#1E293B] p-8 text-amber-50 sm:p-10">
      <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-amber-300/20 blur-3xl" />
      <Crown className="h-7 w-7 text-amber-300" />
      <h2 className="mt-4 font-display text-3xl font-semibold sm:text-4xl">{title}</h2>
      <p className="mt-2 max-w-xl text-amber-100/80">{body}</p>
      <Link to="/plus" data-testid={`${testId}-learn`} className="mt-6 inline-flex rounded-full bg-amber-300 px-6 py-3 text-sm font-semibold text-amber-950 transition-transform hover:-translate-y-0.5">See Cast Plus</Link>
    </div>
  );
}
